import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierSC-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import SCPolicyChangesPage from './pages/SCPolicyChanges/SCPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierSCPolicyChangesPage: { component: 'PremierSCPolicyChangesPage' }
    },
    {
        PremierSCPolicyChangesPage: SCPolicyChangesPage
    }
);

export { default as PremierSCPolicyChangeWizard } from './PremierSCPolicyChangeWizard';
